// extracted by mini-css-extract-plugin
export default {"headerAlert":"headerAlert-AATf14","text":"text-NRcATZ","confirmBtn":"confirmBtn-mDxYEW","cancelBtn":"cancelBtn-K2R5Vv"};